/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const AllProducts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/All products"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#5E1FF0"
      fillRule="evenodd"
      d="M19.484 12.833c1.39 0 2.516 1.12 2.516 2.5V19.5c0 1.38-1.126 2.5-2.516 2.5h-4.193a2.51 2.51 0 0 1-2.516-2.5v-4.167c0-1.38 1.127-2.5 2.516-2.5zm-4.193 1.75a.75.75 0 0 0-.755.75V19.5c0 .414.338.75.755.75h4.193a.75.75 0 0 0 .754-.75v-4.167a.75.75 0 0 0-.754-.75zM6.154 13.09a1.26 1.26 0 0 1 1.091 0l2.678 1.282c.345.165.596.477.681.848l.662 2.88c.085.371-.005.76-.243 1.057l-1.854 2.31c-.238.298-.6.471-.983.471H5.213a1.26 1.26 0 0 1-.983-.47l-1.854-2.31a1.24 1.24 0 0 1-.242-1.057l.66-2.881c.086-.37.336-.683.681-.848zm-1.696 2.755-.554 2.41 1.552 1.934h2.488l1.551-1.935-.554-2.41L6.7 14.773zM17.387 2C19.934 2 22 4.052 22 6.583s-2.065 4.584-4.613 4.584c-2.547 0-4.612-2.053-4.612-4.584S14.84 2 17.387 2m0 1.75a2.843 2.843 0 0 0-2.85 2.833 2.843 2.843 0 0 0 2.85 2.834 2.843 2.843 0 0 0 2.851-2.834 2.84 2.84 0 0 0-2.85-2.833M5.362 2.71c.47-.905 1.773-.903 2.239.004l3.193 6.218c.427.832-.182 1.818-1.121 1.818H3.259c-.941 0-1.549-.99-1.118-1.822zM4.085 9H8.85L6.48 4.378z"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const AllProductsIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'all-products-icon'}
      icon={AllProducts}
      {...props}
      size={size}
    />
  );
};
